<template>
  <div class="farmland-list">
    <div class="farmland-left">
      <div class="farmland-title">高标准农田区域分布</div>
      <div class="map-box">
        <div class="map"></div>
      </div>
    </div>
    <div class="farmland-right">
      <div class="right-top-box">
        <div class="farmland-title">
          <span>高标准农田建设面积分析</span>
          <div class="title-right">
            <el-radio-group v-model="tabPosition" @change="change">
              <el-radio-button v-for="item,index in initRadios" :label="item" :key="index">{{item}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="farmlandAreaEchart">
           <component :is="userAsset"></component>
        </div>
      </div>
       <div class="right-bottom-box">
        <div class="farmland-title">
          <span>高标准农田建设投入分析</span>
          <div class="title-right">
            <el-radio-group v-model="tabPosition2" @change="change2">
              <el-radio-button v-for="item,index in initRadios2" :label="item" :key="index">{{item}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="farmlandAreaEchart">
           <component :is="userAsset2"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AreaAxis from '../../components/echarts/farmlandAreaAxis.vue'
  import AreaTime from '../../components/echarts/farmlandAreaTime.vue'
  import InjectAxis from '../../components/echarts/farmlandInjectAxis.vue'
  import InjectTime from '../../components/echarts/farmlandInjectTime.vue'
  export default {
    name: "farmland",
    data() {
      return {
        tabPosition: '时间',
        initRadios: ['时间', '区域'],
        tabPosition2: '时间',
        initRadios2: ['时间', '区域'],
        userAsset:'AreaTime',
        userAsset2:'InjectTime',
      }
    },
    methods:{
      change(val) {
        if(val=="时间") {
          this.userAsset="AreaTime";
        }
        else {
          this.userAsset="AreaAxis";
        }
      },
       change2(val) {
        if(val=="时间") {
          this.userAsset2="InjectTime";
        }
        else {
          this.userAsset2="InjectAxis";
        }
      }
    },
    components: {
      AreaAxis,
      AreaTime,
      InjectAxis,
      InjectTime
    }

  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/lib-variable";
  @import "../../assets/css/lib-mixin";
  .farmland-list{
    width:100%;
    height:433px;
    justify-content: space-between;
    display: flex;
  }
  .farmland-left {
    width:calc((100% - 20px) / 2);
    height:100%;
    border: solid 1px rgba(0, 255, 238, 0.5);
    background-color: #002624;
    box-sizing: border-box;
    // background-clip:padding-box,border-box;
	  // background-origin:padding-box,border-box;
    // background-image:linear-gradient(#012523,#081411),linear-gradient(#009288,#048a80);
  }
  .farmland-right{
    width:calc((100% - 20px) / 2);
    height:100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .farmland-title{
    width:calc(100% - 22px);
    padding:0 10px 0 12px;
    height:30px;
    @include linear(#009288, #013839, 90deg);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .right-top-box, .right-bottom-box{
    width:100%;
    height: calc((100% - 10px) / 2);
    border: solid 1px rgba(0, 255, 238, 0.5);
    background-color: #002624;
    box-sizing: border-box;
    // border:1px solid transparent;
    /*background-clip:padding-box,border-box;
	  background-origin:padding-box,border-box;
    background-image:linear-gradient(#012523,#081411),linear-gradient(#009288,#048a80);*/
  }
  .title-right {
    display: inline-block;
    /*float: right;*/
    // margin-top: -1px;
  }
  .title-right /deep/ .el-radio-group {
    background-color: #071210;
    border-radius: 11px;
    border: solid 1px rgba(0, 248, 153, 0.3);
  }

  .title-right /deep/ .el-radio-button__inner {
    height: 20px;
    padding: 4px 20px;
  }

  .title-right /deep/ .el-radio-button .el-radio-button__inner {
    background: #002624;
    border-color: rgba(0, 248, 153, 0.3);
  }

  .title-right /deep/ .el-radio-button.is-active .el-radio-button__inner {
    background: #009288;
  }

  .title-right /deep/ .el-radio-button .el-radio-button__inner {
    color: #a4cabd;
  }

  .title-right /deep/ .el-radio-button.is-active .el-radio-button__inner {
    color: #ffffff;
  }

  .title-right /deep/ .el-radio-button:focus {
    box-shadow: 0 0 1px 1px rgba(0, 248, 153, 0.3);
  }

  .title-right /deep/ .el-radio-button:first-child .el-radio-button__inner, .title-right /deep/ .el-radio-button:first-child:focus {
    border-top-left-radius: 11px;
    border-bottom-left-radius: 11px;
  }

  .title-right /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-left: none;
  }

  .title-right /deep/ .el-radio-button .el-radio-button__inner {
    line-height: 11px;
  }

  .title-right /deep/ .el-radio-button:last-child .el-radio-button__inner, .title-right /deep/ .el-radio-button:last-child:focus {
    border-top-right-radius: 11px;
    border-bottom-right-radius: 11px;
  }
  .chart-box, .map-box {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    height: calc(100% - 30px);
  }
  .map {
    position: absolute;
    top: 0;
    left: 50%;
    background: url('../../../static/img/mapArea.jpg') no-repeat;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    transform: translate(-50%, 0);
    z-index: 90;
  }
  .farmlandAreaEchart{
    width: 100%;
    height: calc(100% - 30px);
    /*height:180px;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/quality/farmland.vue